import {DataObject} from "./dataObject";

export class SaisonTeam extends DataObject {
    constructor(){
        super();
        this.id = '';
        this.name = '';
        this.vereinsNr = '';
        this.vereinsName = '';
        this.lvId = '';
        this.local.definitions.databaseHandlerCall = 'saisonTeam'; // not really used, child of Saison
    }
}